import {QueryClient, QueryCache, MutationCache} from "@tanstack/react-query"

const queryCache = new QueryCache({
  onError: (error, query) => {},
  onSuccess: (data, query) => {},
})
const mutationCache = new MutationCache({
  onError: (error, variables, context, mutation) => {
    console.log("[mutationCache] onError", variables)
  },
  onSuccess: (data, variables, context, mutation) => {
    console.log("[mutationCache] onSuccess", variables)
  },
})

const queryClient = new QueryClient({
  queryCache,
  mutationCache,
  defaultOptions: {
    queries: {
      retry: 0,
      refetchOnWindowFocus: true,
      networkMode: "online",
    },
    mutations: {
      retry: 0,
      networkMode: "online",
    },
  },
})

export const DEFAULT_TIMEOUT = 35000

export const config = {
  defaultRequestConfig: {
    baseURL: `${process.env.STRAPI_API_URL}/api`,
    timeout: DEFAULT_TIMEOUT,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${process.env.STRAPI_TOKEN}`,
    },
  },
  queryClient,
  queryCache,
  mutationCache,
}
